<template>
  <div class="row d-flex align-items-center">
    <div class="col-xl-6 col-12">
      <div class="d-flex justify-content-xl-start justify-content-center mb-3">
        <div class="models-filters" :style="style1" @click="changeOrder('order', 1)">
          {{ translate.models }}
        </div>
        <div class="models-filters" :style="style2" @click="changeOrder('created_at', 2)">
          {{ translate.lastModels }}
        </div>
      </div>
    </div>
    <div class="col-xl-6 col-12">
      <vue-awesome-paginate
        class="justify-content-xl-end justify-content-sm-center mb-3"
        :modelValue="pageAtual"
        :total-items="paginations.total"
        :items-per-page="paginations.per_page"
        :max-pages-shown="isMobileBool ? 1 : 15"
        :on-click="onClickHandler"
        paginate-buttons-class="btn"
      />
    </div>
  </div>
  <div class="row align-items-center mt-2">
    <div v-for="model in arrayModels" class="col-lg-2" :key="model.id">
      <router-link
        :to="{
          name: 'ModelPageChild',
          params: {
            locale: locale,
            name: model.slug,
            complement: 'live-videos'
          }
        }"
      >
        <div class="card-pagination pr-3 pb-4">
          <div class="img-box" @vue:mounted="(event) => observer.observe(event.el)">
            <img
              :src="`${model.cover}`"
              :class="{ 'imagem-estatica': model.gif }"
              :alt="model.title"
              width="227"
              height="168"
            />
            <img
              v-if="model.gif"
              :src="model.gif"
              class="gif"
              :alt="'gif de ' + model.title"
              width="227"
            />
            <div class="play-icon">
              <font-awesome-icon :icon="['fas', 'circle-play']" size="2xl" />
            </div>
          </div>
          <div class="card-body d-flex flex-column align-items-center">
            <h5 class="card-title my-3">{{ model.title }}</h5>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed, onMounted, ref } from 'vue'
  import { localeStore } from '../../stores/locale'
  import modelsTradutor from '../../tradutors/lives'
  import { isMobile } from '../../views/shared/utils/mobile'
  import api from '../../api'

  interface Model {
    id: number
    title: string
    slug: string
    cover: string
  }

  interface Pagination {
    total: number
    per_page: number
    data: Model[]
    current_page: number
  }
  const props = defineProps({
    models: {
      type: Object as () => Pagination,
      required: true
    }
  })

  const storeLocale = localeStore()
  const locale = computed(() => storeLocale.locale)

  const translate = computed(() => {
    if (storeLocale.locale === 'pt-br') {
      return modelsTradutor.portugues
    } else {
      return modelsTradutor.ingles
    }
  })

  const isMobileBool = computed(() => isMobile())
  const pageAtual = ref(1)
  const arrayModels = ref([])
  const paginations = ref({
    total: 1,
    per_page: 1
  })
  const orderBy = ref('order')
  const style1 = ref({ fontWeight: 'bold' })
  const style2 = ref({ fontWeight: 'normal' })

  onMounted(() => {
    arrayModels.value = props.models.data
    paginations.value = props.models
    pageAtual.value = props.models.current_page
  })

  async function onClickHandler(page: number) {
    pageAtual.value = page
    await getNewPage(page)
  }
  async function getNewPage(page) {
    api
      .get('v1/modelos/getLiveModels?order=' + orderBy.value + '&page=' + page)
      .then(({ data }) => {
        const { modelsArray } = data
        paginations.value = modelsArray
        arrayModels.value = modelsArray.data
      })
  }
  async function changeOrder(order, link) {
    orderBy.value = order
    onClickHandler(1)
    ;(style1.value = { fontWeight: 'bold' }), (style2.value = { fontWeight: 'normal' })
    if (link == 2) {
      ;(style2.value = { fontWeight: 'bold' }), (style1.value = { fontWeight: 'normal' })
    }
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Imagem está visível/focada
          setTimeout(() => entry.target.classList.add('focused'), 1500)
        } else {
          entry.target.classList.remove('focused')
        }
      })
    },
    {
      threshold: 0.9, // 70% da imagem precisa estar visível
      rootMargin: '0px'
    }
  )
</script>
<style scoped lang="css">
  .pagination-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: 10px;
  }

  .paginate-buttons {
    height: 40px;
    width: 40px;
    border-radius: 20px;
    cursor: pointer;
    background-color: rgb(242, 242, 242);
    border: 1px solid rgb(217, 217, 217);
    color: black;
  }

  .paginate-buttons:hover {
    background-color: #d8d8d8;
  }

  .active-page {
    background-color: #b20000;
    border: 1px solid #b20000;
    color: white;
  }

  .active-page:hover {
    background-color: #b20000;
  }

  ul#componentContainer {
    display: flex !important;
    justify-content: center;
  }

  .card-title {
    height: 19px;
    color: #666666;
    font-family: 'Exo-2';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
    text-align: center;
  }

  .img-box {
    position: relative;
    width: 100%;
    min-height: 168px;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
  }

  .img-box img {
    filter: brightness(0.7);
    background-size: cover;
    background-position: center;
  }

  .play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    /* Tamanho do ícone de reprodução */
    color: white;
    /* Cor do ícone de reprodução */
    cursor: pointer;
  }

  .card-pagination {
    background-color: transparent;
  }

  .models-filters {
    font-family: 'Bebas-Neue';
    font-size: 20px;
    font-weight: 300;
    padding: 0px 10px;
    border-left: 1px solid #666666;
    border-right: 1px solid #666666;
    cursor: pointer;
  }

  .col-lg-2 {
    width: 20%;
  }

  .imagem-estatica {
    position: absolute;
    /* Coloca a imagem estática acima do GIF */
  }
  .gif {
    opacity: 0; /* Inicialmente invisível */
    transition: opacity 0.3s; /* Transição suave */
    z-index: 2;
  }
  .img-box:hover .gif {
    opacity: 1; /* Torna o GIF visível ao passar o mouse */
  }
  .img-box:hover .imagem-estatica {
    opacity: 0; /* Torna a imagem estática invisível ao passar o mouse */
  }

  @media screen and (min-width: 780px) {
    .img-box:hover .gif {
      transform: scale(1.4);
      transition: transform 0.5s ease;
    }
  }
  /* regras mobile 769vp */
  @media screen and (max-width: 769px) {
    .col-lg-2 {
      width: 100%;
    }

    .img-box img {
      width: 90%;
    }

    .img-box {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .focused .imagem-estatica {
      opacity: 0;
    }

    .focused .gif {
      opacity: 1;
    }
    .gif {
      height: 244px;
    }

    .imagem-estatica {
      height: 244px !important;
    }
  }
  @media screen and (max-width: 375px) {
    .imagem-estatica {
      height: 175px !important;
    }
    .gif {
      height: 175px !important;
    }
  }
</style>
